import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { ResponseData } from "services/common"

// This API is used to set the import calendar link for location details screen [step 2]
export interface ImportCalendarLinkDataType {
  pmcId: string
  pmsUnitId: string
  propertyId: string
  eventsCreated: {
    description: string
    endDate: string
    startDate: string
    summary: string
    uid: string
  }
}

export interface GetImportCalendarLinkResponseData extends ResponseData {
  data: ImportCalendarLinkDataType | string
}

export interface GetImportCalendarLinkResponse extends AxiosResponse {
  data: GetImportCalendarLinkResponseData
}

export interface SetCalendarImportLinkRequestData {
  pmsUnitId: string
  pmcId: string
  calendarLink: string
  icalLinkPlatformName: string
}
export interface SetCalendarImportLinkRequest
  extends Partial<AxiosRequestConfig> {
  data: SetCalendarImportLinkRequestData
  params: {
    isPublishProperty: boolean
    listingReviewStep: string
  }
}

const defaultImportCalendarLinkUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/calendar/import`

export function setImportCalendarLink(
  {
    params,
    data,
    method = "post",
    url = defaultImportCalendarLinkUrl,
    ...config
  }: SetCalendarImportLinkRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetImportCalendarLinkResponse> {
  return axiosInstance({
    method,
    params,
    url: `${url}`,
    data,
    ...config,
  }) as Promise<GetImportCalendarLinkResponse>
}
